import { getRequest } from '../services/requestHandler';
import { InternalStatusLookup } from '../models';

export const getInternalStatusLookups = async () => {
  const url = 'player/getInternalStatusLookups?activeOnly=true&useCache=true';
  const response = await getRequest<InternalStatusLookup>('getInternalStatusLookups', url);
  return response;
};
